@use "../../styles/Constants.scss" as Constants;

.email-input-container {
	display: flex;
	align-items: center;
	margin-right: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-xs;
	height: Constants.$val-fieldSize;
	width: fit-content;
}

.create-email {
	margin-top: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-s;
	margin-left: Constants.$val-spacing-l;
}